import CommonProcess from 'app/components/OrderPayment/Common/CommonProcess';
import React from 'react';

const PaypalPaymentMob = () => {
  return <CommonProcess />;
};

export default PaypalPaymentMob;
